module.exports = __webpack_public_path__ + "static/media/emprendimiento.39f8f298.png";